module.exports = __webpack_public_path__ + "static/media/daniel.fcfe2bd1.jpg";